import { FieldPathUtils } from '../../../utils/fieldpath-utils';
import { templateContext } from '../../../utils/template-context';
import { SerializedFieldContext } from '../../content-control-to-field-map.service';
import { PasteLocation } from '../paste-location';
import { IPasteRule } from './ipasterule';

export class PasteEntityFieldInDocumentLocationRule implements IPasteRule {
  canPaste(pasteLocation: PasteLocation, pasteField: SerializedFieldContext): boolean {
    return pasteField.entity === templateContext.getTargetEntity().entity && FieldPathUtils.tailless(pasteField.path) === pasteField.entity; // is child of root entity?
  }
}
